import { render } from "./HeaderBar.vue?vue&type=template&id=2f9dc19e"
import script from "./HeaderBar.vue?vue&type=script&lang=js"
export * from "./HeaderBar.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/Sites/mystudentvue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__